export default "__VITE_ASSET__BF5kvc0C__"